import React from "react";
import "./logo-carousel.scss";

import ferrari from "./../../image/clientLogos/ferrari.svg";
import maserati from "./../../image/clientLogos/maserati.svg";
import stellantis from "./../../image/clientLogos/Stellantis.svg";
import jeep from "./../../image/clientLogos/jeep.svg";
import leapmotor from "./../../image/clientLogos/leapmotor.svg";
import generali from "./../../image/clientLogos/generali.svg";
import allianz from "./../../image/clientLogos/Allianz.svg";
import sisal from "./../../image/clientLogos/Sisal.svg";
import snai from "./../../image/clientLogos/snai.png";
import pokerstars from "./../../image/clientLogos/pokerstars.svg";

const logos = [
  ferrari,
  maserati,
  stellantis,
  jeep,
  leapmotor,
  generali,
  allianz,
  sisal,
  snai,
  pokerstars,
];

const LogoCarousel: React.FC = () => {
  return (
    <div className="logo-carousel" aria-label="Selected clients">
      <div className="logo-track">
        {logos.map((src, i) => (
          <div className="logo-item" key={`logo-${i}`}>
            <img src={src} alt="" loading="lazy" />
          </div>
        ))}
        {logos.map((src, i) => (
          <div className="logo-item" key={`logo-dup-${i}`}>
            <img src={src} alt="" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoCarousel;